export default {"src":"https://wp-static.smartkarma.com/_next/static/media/comparables.d2bc4516.svg","height":640,"width":640,"blurWidth":0,"blurHeight":0};